"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterviewCompletedFilter = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
/**
 * Textbox input for column filter
 *
 * @param param0 description of the filtered column
 * @returns
 */
const InterviewCompletedFilter = ({ t, column: { filterValue, setFilter } }) => {
    const options = react_1.default.useMemo(() => ({ all: undefined, true: 'true', false: { value: null } }), []);
    const currentSelection = Object.keys(options).find((key) => (0, isEqual_1.default)(filterValue, options[key]));
    return (react_1.default.createElement("div", { style: { display: 'flex', margin: '2px 0' } },
        react_1.default.createElement("label", { htmlFor: 'surveyValidation-filter-completed' }, t('admin:interviewCompletedFilter:title')),
        react_1.default.createElement("select", { id: 'surveyValidation-filter-completed', value: currentSelection, onChange: (e) => {
                setFilter(options[e.target.value] || undefined);
            } }, Object.keys(options).map((key, _i) => (react_1.default.createElement("option", { key: `interviewCompleted_${key}`, value: key }, t(`admin:interviewCompletedFilter:${key}`)))))));
};
exports.InterviewCompletedFilter = InterviewCompletedFilter;
exports.default = (0, react_i18next_1.withTranslation)(['admin', 'main'])(exports.InterviewCompletedFilter);
//# sourceMappingURL=InterviewCompletedFilter.js.map